var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3742 3.00112L17.3777 5.00462L16.8153 5.56709L12.3155 10.0668L11.5416 10.8756L13.1232 12.4573L13.9321 11.6833L18.4318 7.18361L18.9943 6.62115L20.9978 8.62465V3H15.3731L15.3742 3.00112ZM3 5.25098V21H18.749V12.0006H16.4992V18.7501H5.24986V7.50084H11.9994V5.25098H3Z",
    fill: "#646471"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.0569b6fd137ab510860f49e4d6c850f7.svg";
export { ForwardRef as ReactComponent };